import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import theme from 'theme';
import useWindowSize from 'hooks/useWindowsSize';
import { scrollToTop, waitForElm } from 'utils/common.util';
import Icon from 'components/Common/Icon';
import { StyledDiv } from './style';

const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [width] = useWindowSize();
  const router = useRouter();
  const hasNavbar = !!document.getElementById('navbar');

  useEffect(() => {
    const tableElement = document?.querySelector('.ReactVirtualized__Grid');
    const toggleVisibility = (elm): void => {
      // if the user scrolls down, show the button
      // check window scroll and element scroll position
      setIsVisible(!!(window.scrollY > 500 || elm?.scrollTop > 500));
    };

    (async (): Promise<void> => {
      const elm = await waitForElm('.ReactVirtualized__Grid');
      // listen for scroll events on current table
      elm?.addEventListener('scroll', () => toggleVisibility(elm));
    })();
    // listen for scroll events on window
    window.addEventListener('scroll', toggleVisibility);
    return (): void => {
      // clear the listener on component unmount
      window.removeEventListener('scroll', toggleVisibility);
      tableElement?.removeEventListener('scroll', toggleVisibility);
      setIsVisible(false);
    };
    // update state wuth changing route
  }, [router.asPath]);

  return (
    <StyledDiv
      isVisible={isVisible}
      clientWidth={width}
      hasNavbar={hasNavbar}
      onClick={(): void => scrollToTop(isVisible)}
    >
      <Icon
        color={theme.colors.blue100}
        fontSize={15}
        fontWeight={5}
        lineHeight={1}
        name="chevron-up"
      />
    </StyledDiv>
  );
};

export default ScrollToTopButton;
